import styles from './RecaptchaDisclaimer.module.scss';

export default function RecaptchaDisclaimer() {
  return (
    <div className={styles.recaptchaDisclaimer}>
      Deze site wordt beschermd door reCAPTCHA en Google,{' '}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener"
      >
        Privacybeleid
      </a>{' '}
      en{' '}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener"
      >
        Servicevoorwaarden
      </a>{' '}
      zijn van toepassing
    </div>
  );
}
